'use strict';

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/locale-provider/style/css.js
// module id = 569
// module chunks = 0